import { __awaiter, __generator } from "tslib";
import { match as createMatchFunction, parse as parsePattern, } from 'path-to-regexp';
import { normalizePathname, parseLocation } from 'retil-history';
// Wait for a list of promises that may have grown by the time the first
// promises resolves.
export function waitForResponse(response) {
    return __awaiter(this, void 0, void 0, function () {
        var promises, waitingPromises, i, promise, pendingIndex;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    promises = response.pendingSuspenses;
                    _a.label = 1;
                case 1:
                    if (!promises.length) return [3 /*break*/, 3];
                    waitingPromises = promises.slice(0);
                    // Use `Promise.all` to eagerly start any lazy promises
                    return [4 /*yield*/, Promise.all(waitingPromises)];
                case 2:
                    // Use `Promise.all` to eagerly start any lazy promises
                    _a.sent();
                    for (i = 0; i < waitingPromises.length; i++) {
                        promise = waitingPromises[i];
                        pendingIndex = promises.indexOf(promise);
                        if (pendingIndex !== -1) {
                            promises.splice(pendingIndex, 1);
                        }
                    }
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function createRequest(action, ext) {
    return Object.assign(parseLocation(action), { basename: '', params: {} }, ext);
}
export function createMatcher(rawPattern) {
    var normalizedPattern = normalizePathname(rawPattern.replace(/^\.?\/?/, '/'));
    if (normalizedPattern.slice(normalizedPattern.length - 2) === '/*') {
        normalizedPattern =
            normalizedPattern.slice(0, normalizedPattern.length - 2) + '/(.*)?';
    }
    else if (normalizedPattern.slice(normalizedPattern.length - 1) === '*') {
        normalizedPattern =
            normalizedPattern.slice(0, normalizedPattern.length - 1) + '/(.*)?';
    }
    else if (normalizedPattern === '/*') {
        normalizedPattern = '/(.*)?';
    }
    var lastToken = parsePattern(normalizedPattern).pop();
    var wildcardParamName = lastToken && typeof lastToken !== 'string' && lastToken.pattern === '.*'
        ? String(lastToken.name)
        : undefined;
    var matchFunction = createMatchFunction(normalizedPattern, {
        encode: encodeURI,
        decode: decodeURIComponent,
    });
    var matcher = function (pathname) {
        var match = matchFunction(pathname);
        if (match) {
            var params = match.params;
            var wildcard = '';
            if (wildcardParamName) {
                wildcard = params[wildcardParamName] || '';
                delete params[wildcardParamName];
            }
            return {
                params: params,
                pathname: pathname
                    .slice(0, pathname.length - wildcard.length)
                    .replace(/\/$/, ''),
            };
        }
        return false;
    };
    return matcher;
}
export function isRedirect(response) {
    return response.status && response.status >= 300 && response.status < 400;
}
